/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import idIcon from "../../../assets/icons/progress/icon_progressbar_personal_data.svg";
import calculateIcon from "../../../assets/icons/progress/icon_progressbar_calculate.svg";
import questionIcon from "../../../assets/icons/progress/icon_progressbar_frage.svg";
import documentIcon from "../../../assets/icons/progress/icon_progressbar_document.svg";
import documentsIcon from "../../../assets/icons/progress/icon_progressbar_vertrag_upload.svg";

const progressBarsteps = [
  {
    key: "base",
    name: "Meine Analyse",
    icon: documentIcon,
  },
  {
    key: "calculate",
    name: "Berechnung",
    icon: calculateIcon,
  },
  {
    key: "question",
    name: "Mein Anliegen",
    icon: questionIcon,
  },
  {
    key: "documents",
    name: "Unterlagen",
    icon: documentsIcon,
  },
  {
    key: "personal",
    name: "Persönliche Angaben",
    icon: idIcon,
  },
];

export default progressBarsteps;
